import { useEffect } from 'react';
import { useUserIndexActions } from './UserIndexContext';

import { getUsers } from './restApi';

const UserIndexLoader = () => {
  const { initializeState, onResponse, onError } = useUserIndexActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getUsers({ onResponse, onError });
  }, []);

  return null;
};

export default UserIndexLoader;
